<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-btn
                                absolute
                                dark
                                fab
                                bottom
                                left
                                small
                                depressed
                                title="Wybierz z bazy opisów"
                                color="success"
                                @click="showDescriptionPicker = true"
                        >
                            <v-icon>fa-database</v-icon>
                        </v-btn>
                        <v-btn
                                absolute
                                dark
                                fab
                                bottom
                                right
                                small
                                depressed
                                title="Skopiuj z poprzedniej wizyty"
                                color="primary"
                                @click="copyLatest()"
                                v-if="details != null && details.latestRecommendations"
                        >
                            <v-icon>fa-plus</v-icon>
                        </v-btn>
                        <v-container fluid>
                            <v-row>
                                <v-col cols="12">
                                    <tiptap-vuetify v-model="recommendations" name="recommendations" 
                                                   @input="$emit('recommendations', $event)"
                                                   :extensions="extensions"
                                                   :toolbar-attributes="{ color: 'primary' }"
                                                   placeholder="Zalecenia..." />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12">
                        <Recepty v-if="this.userdetails != null && this.details != null" :clientid="details.client_id" :visitid="details.visitId" :therapistid="this.userdetails.id"></Recepty>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-dialog v-model="showDescriptionPicker" width="768">
            <DescriptionPicker :type="1" @close="closingPicker" v-if="showDescriptionPicker"></DescriptionPicker>
        </v-dialog>
    </div>
</template>

<script>
    import DescriptionPicker from "../descriptions/DescriptionPicker";
    import Recepty from "@/components/clients/Recepty.vue";
    import {mapState} from "vuex";
    import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Blockquote, HardBreak, History } from 'tiptap-vuetify'

    export default {
        name: "TherapistVisitRecommendations",
        props: ['details'],
        components: {Recepty, DescriptionPicker, TiptapVuetify},
        data() {
            return {
                recommendations: this.details != null ? this.details.recommendations : null,
                showDescriptionPicker: false,
                extensions: [
                    History,
                    Blockquote,
                    Underline,
                    Strike,
                    Italic,
                    ListItem,
                    BulletList,
                    OrderedList,
                    [Heading, {
                        options: {
                            levels: [1, 2, 3]
                        }
                    }],
                    Bold,
                    Code,
                    Paragraph,
                    HardBreak
                ]
            }
        },
      mounted() {
          
      },
      computed: {
        ...mapState('account', ['userdetails']),
      },
      methods: {
            copyLatest() {
                if(this.recommendations)
                    this.recommendations += this.details.latestRecommendations
                else
                    this.recommendations = this.details.latestRecommendations

                this.$emit('recommendations', this.recommendations)
            },
            closingPicker(desc)
            {
                if(desc != null)
                {
                    if(!this.recommendations)
                    {
                        this.recommendations = desc.description
                    }
                    else
                    {
                        this.recommendations += "\r\n"+desc.description;
                    }
                }
                this.showDescriptionPicker = false
            },
        }
    }
</script>

<style scoped>

</style>